import { render, staticRenderFns } from "./BulkImportGlobalStatus.vue?vue&type=template&id=45c22cae&"
import script from "./BulkImportGlobalStatus.vue?vue&type=script&lang=js&"
export * from "./BulkImportGlobalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports